import axiosClient from './AxiosClient';
export const SupportApi = {
    getSupport(type) {
        const url = `services/search?type=${type}`;
        return axiosClient.get(url);
    },
};
